import { atom } from 'recoil';

const sessionStorageEffect = (key) => ({ setSelf, onSet }) => {
  const saved = sessionStorage.getItem(key);
  if (saved) {
    try { setSelf(JSON.parse(saved)); } catch (e) { /* ignore */ }
  }
  onSet((newValue, _, isReset) => {
    isReset
      ? sessionStorage.removeItem(key)
      : sessionStorage.setItem(key, JSON.stringify(newValue));
  });
};

export const sisCourseState = atom({
  key: 'sisCourseState',
  default: {
    openYy: null,
    openTmGbn: null,
    scCd: null,
    openDeptCd: null,
  },
  effects_UNSTABLE: [sessionStorageEffect('recoil_sisCourse')],
});
